/* unplugin-vue-components disabled */import { render } from "./xsplit.vue?vue&type=template&id=e7b9d562"
import script from "./xsplit.vue?vue&type=script&lang=js"
export * from "./xsplit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__